import axios from "axios";
import urls from "../../urls";

/**
 * Updates counted stock for a single product
 * @param {string} productId - Product ID
 * @param {string} dateId - Date ID (DDMMYYYY format)
 * @param {number} newCountedStock - New counted stock value
 * @param {string} countryCode - Country code
 * @param {string} token - Firebase auth token
 * @param {boolean} trackAddedRemoved - Whether to track addedStock/removedStock (default: true)
 *   - true: Use when stock is physically added to warehouse (incoming goods)
 *   - false: Use when adjusting stock for other reasons (sold items, corrections, etc.)
 */
export const updateCountedStock = (productId, dateId, newCountedStock, countryCode, token, trackAddedRemoved = true) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    const payload = {
      productId,
      dateId,
      newCountedStock,
      trackAddedRemoved,
    };

    axios
      .put(`${urls.updateDateCountedStock}/${countryCode}`, payload, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error updating counted stock:", error);
        reject(error.response?.data?.message || error.message);
      });
  });
};

/**
 * Updates counted stock for multiple products in a batch
 * @param {Array} updates - Array of {productId, newCountedStock} objects
 * @param {string} dateId - Date ID (DDMMYYYY format)
 * @param {string} countryCode - Country code
 * @param {string} token - Firebase auth token
 * @param {boolean} trackAddedRemoved - Whether to track addedStock/removedStock (default: true)
 *   - true: Use when stock is physically added to warehouse (incoming goods)
 *   - false: Use when adjusting stock for other reasons (sold items, corrections, etc.)
 */
export const updateBatchCountedStock = (updates, dateId, countryCode, token, trackAddedRemoved = true) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    const payload = {
      updates,
      trackAddedRemoved,
    };

    axios
      .put(`${urls.updateBatchCountedStock}/${countryCode}/${dateId}`, payload, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error updating batch counted stock:", error);
        reject(error.response?.data?.message || error.message);
      });
  });
};
